// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n  font-family: sans-serif;\n  font-size: 16px;\n  margin: 0; }\n", "",{"version":3,"sources":["webpack://src/styles/styles.scss"],"names":[],"mappings":"AAAA;EACI,uBAAuB;EACvB,eAAe;EACf,SAAS,EAAA","sourcesContent":["body {\n    font-family: sans-serif;\n    font-size: 16px;\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
